import React from "react";
import RadioGroup from "../RadioGroup";
import { MEASUREMENT_SYSTEM } from "../constants";
import t from "../../../utils/translate";
import { METRIC, IMPERIAL } from "../../../utils/measurementSystem";

const name = MEASUREMENT_SYSTEM;
const options = [
  {
    value: METRIC,
    label: t("METRIC")
  },
  {
    value: IMPERIAL,
    label: t("IMPERIAL")
  }
];

function MeasurementSystemPicker({ value, onChange }) {
  const props = { value, onChange, options, name };
  return <RadioGroup {...props} />;
}

export default MeasurementSystemPicker;
